import React, { useState } from 'react';
import {
  Container,
  Typography,
  TextField,
  Button,
  Box,
  Paper,
  Alert,
} from '@mui/material';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

const RegisterForm = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
    setSuccess('');
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API_BASE_URL}/registration/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error('HTTP error ' + response.status);
      }

      setSuccess("Un e-mail de vérification vous a été envoyé !");
      setFormData({ email: '', password: '' });
    } catch (err) {
      console.error(err);
      setError("Échec de l’inscription. Vérifiez vos informations.");
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom>
          Inscription
        </Typography>
        <Typography variant="body1" gutterBottom>
          Créez votre compte en saisissant votre adresse e-mail et un mot de passe sécurisé. Vous recevrez un lien de vérification par e-mail.
        </Typography>

        {error && <Alert severity="error" sx={{ my: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ my: 2 }}>{success}</Alert>}

        <Box component="form" onSubmit={handleSubmit} noValidate>
          <TextField
            required fullWidth type="email"
            label="Adresse e-mail" name="email"
            value={formData.email} onChange={handleChange}
            sx={{ mb: 2 }}
          />
          <TextField
            required fullWidth type="password"
            label="Mot de passe" name="password"
            value={formData.password} onChange={handleChange}
            sx={{ mb: 3 }}
          />
          <Button
            type="submit" variant="contained"
            color="primary" fullWidth
          >
            S’inscrire
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default RegisterForm;
